module.exports = {"623022100":"柳林镇","623022101":"木耳镇","623022102":"扎古录镇","623022200":"纳浪乡","623022201":"喀尔钦乡","623022202":"刀告乡","623022203":"尼巴乡","623022204":"完冒乡","623022205":"阿子塘乡","623022206":"申藏乡","623022207":"恰盖乡","623022208":"康多乡","623022209":"勺哇土族乡","623022210":"洮砚乡","623022211":"藏巴哇乡","623022400":"卓尼县林场","623022401":"国营大峪牧场","623022402":"国营柏林牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/623022.json
// module id = 2760
// module chunks = 0